import React, {PropTypes} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import selectAllProps from './selectors';
import {
    MenuItem,
    RaisedButton
} from 'material-ui';
import {TextField, SelectField} from 'redux-form-material-ui';

class UserForm extends React.Component {

    render() {
        const roles = this.props.roles;
        const validateButtonLabel = (this.props.user) ? 'Modifier' : 'Ajouter';
        return (
            <form onSubmit={this.props.handleSubmit} autoComplete="false">
                <Field
                    name="firstname"
                    component={TextField}
                    hintText="Prénom"
                    floatingLabelFixed
                    floatingLabelText="Prénom"
                    errorText={this.props.errors && this.props.errors.firstname && this.props.errors.firstname[0]}
                    style={{width: '100%'}}/>
                <Field
                    name="lastname"
                    component={TextField}
                    hintText="Nom"
                    floatingLabelFixed
                    floatingLabelText="Nom"
                    errorText={this.props.errors && this.props.errors.lastname && this.props.errors.lastname[0]}
                    style={{width: '100%'}}/>
                <Field
                    name="email"
                    component={TextField}
                    hintText="Email"
                    floatingLabelFixed
                    floatingLabelText="Email"
                    type="email"
                    errorText={this.props.errors && this.props.errors.email && this.props.errors.email[0]}
                    style={{width: '100%'}}/>
                {!this.props.user && <Field
                    name="password"
                    component={TextField}
                    hintText="Mot de passe"
                    floatingLabelFixed
                    floatingLabelText="Mot de passe"
                    type="password"
                    style={{width: '100%'}}
                />}
                {!this.props.user && <Field
                    name="password_confirm"
                    component={TextField}
                    hintText="Confirmation de mot de passe"
                    floatingLabelFixed
                    floatingLabelText="Confirmation de mot de passe"
                    type="password"
                    style={{width: '100%'}}
                />}
                <Field
                    name="role_id"
                    component={SelectField}
                    hintText="Role"
                    floatingLabelFixed
                    floatingLabelText="Role"
                    style={{width: '100%'}}
                    >
                    {roles.map((role)=>(
                        <MenuItem key={role.id} value={role.id} primaryText={role.name}/>
                    ))}
                </Field>
                <div style={{display: 'inline-block', width: '100%', position: 'relative'}}>
                    <RaisedButton type="submit" label={validateButtonLabel} primary
                                  disabled={this.props.pristine || this.props.submitting}/> &nbsp;
                    <RaisedButton label="Réinitiliser" secondary disabled={this.props.pristine || this.props.submitting} onClick={this.props.reset}/>
                </div>
            </form>
        );
    }
}

UserForm.propTypes = {
    user: PropTypes.object,
    roles: PropTypes.array,
    errors: PropTypes.array,
    reset: PropTypes.func,
    pristine: PropTypes.bool,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool
};

export default connect(selectAllProps)(reduxForm({form: 'userForm'})(UserForm));


/** WEBPACK FOOTER **
 ** ./src/form/UserForm/index.js
 **/